module.exports = __webpack_public_path__ + "static/media/progress_foto.9f1a93bc.svg";